module.exports = __webpack_public_path__ + "static/media/img-exhibition-panel.62e3360d.jpg";